module.exports = __webpack_public_path__ + "img/lounge.6eb40b11.svg";